import React, { Component } from 'react';
import axios from '../../axios';
import qs from 'qs';
import Alert from 'react-s-alert'
import FormDropdown from '../../components/FormDropdown'
import { status_aktif } from '../../constants/general'
import Dropzone from 'react-dropzone'
import { MEDIA_HOST } from '../../constants/siteConfig'
import Select from "react-select";

class Forms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            materi_id           : "",
            materi_judul        : "",
            materi_tipe         : "video",
            materi_status       : "",
            materi_file_exist   : "", 
            materi_file         : "",
            dataMapel           : [],
            mapel_id            : "",
            dataGuru            : [],
            dataKelas           : [],
            isdataLoaded        : false,
            isButtonLoading     : false,
            isLoading           : false,
            isLoadingDataKelas: false,

        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeMultiSelect = this.handleChangeMultiSelect.bind(this);
    }

    handleChange(event) {
        
        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })        
    }

    loadDataKelas() {
        this.setState({isLoadingDataKelas: true});

        const params = qs.stringify({
            locale: "id",
            platform: "web"
        })
        axios({
            method: 'post',
            url: '/kelas'
        })

            .then(response => {
                const result = response.data;
                if (result.success) {
                    const dataKelas = result.data.map(item => ({
                        value: item.kelas_id,
                        label: item.kelas_nama
                    }));

                    this.setState({
                        dataKelas,
                        isLoadingDataKelas: false
                    });
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({isLoadingDataKelas: false});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({isLoadingDataKelas: false});
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataMapel() {

        axios.post("/mapel")
            .then(response => {

                return response.data.mapelexport.map(item => ({
                    key: item.mapel_id,
                    value: item.mapel_nama
                }))
            })
            .then(result => {

                this.setState({
                    dataMapel: result
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    handleChangeMultiSelect(stateName, text) {
        this.setState({[stateName]: text});

        if (stateName == 'participants') {
            let kelas = [];
            for (var i = 0; i < text.length; i++) {
                kelas.push(text[i].value);
            }

            const kelasNew = kelas.join(',');

            this.setState({
                kelasNew
            });
        }

    }

    handleSubmit() {

        let formData = new FormData();

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        
        formData.append('materi_id', this.state.materi_id)
        formData.append('materi_tipe', this.state.materi_tipe)
        formData.append('materi_judul', this.state.materi_judul)
        formData.append('materi_status', this.state.materi_status)
        formData.append('materi_file', this.state.materi_file)
        formData.append('kelas_id', this.state.kelasNew)
        formData.append('mapel_id', this.state.mapel_id)

        const url = this.props.mode === "Tambah" ? "video/add" : "video/edit"

        this.setState({ isButtonLoading: true })

        axios.post(url, formData, config)
            .then(response => {
                
                const result = response.data;

                if (result.success) {

                    Alert.success(result.message)
                    this.props.history.replace("/video")
                }
                else {

                    if (Array.isArray(result.message)) {

                        result.message.map(item => {
                            Alert.error(item)

                            return true
                        })
                    }
                    else {

                        Alert.error(result.message)
                    }

                    this.setState({ isButtonLoading: false })
                }             
            }) 
            .catch(error => {
                
                console.log("ERROR", error)
                Alert.error("Gagal terhubung ke server!")
                this.setState({ isButtonLoading: false })
            })
    }

    handleDeleteFile() {

        this.setState({
            materi_file: ""
        })
    }

    onDrop(files) {

        this.setState({
            materi_file: files[0]
        });
    }

    loadData() {

        if (this.props.mode === "Edit") {  
            
            this.setState({ isLoading: true, isdataLoaded: false })

            axios({
                method: 'get',
                url: '/video/' + this.props.match.params.materi_id
            })
                .then(response => {

                    const result = response.data

                    if (result.success) {

                        this.setState({
                            materi_id         : result.data.materi_id,
                            materi_judul      : result.data.materi_judul,                            
                            materi_status     : result.data.materi_status,
                            materi_file       : 'https://www.youtube.com/watch?v='+result.data.materi_file,
                            kelas_id          : result.data.kelas_id.split(","),
                            mapel_id          : result.data.mapel_id,
                            isLoading         : false,
                            isdataLoaded      : true
                        });

                        var data_kelas_id = []

                        for (var i=0; i<this.state.kelas_id.length; i++) {
                            var arr_kelas_id =[]
                            arr_kelas_id["kelas_id"]= this.state.kelas_id[i]
                            data_kelas_id[i] = arr_kelas_id
                        }

                        const participants = data_kelas_id.map(
                            item => item.kelas_id
                        );

                        const kelasNew = data_kelas_id.map(item => ({
                            "kelas_id": item.kelas_id
                        }));
                        //
                        // newState.participants = participants.join(",");
                        // newState.kelasNew = kelasNew

                        this.setState(
                            {
                                kelasNew: participants.join(","),
                                participants: participants.join(",")
                            }
                        );
                    }   
                    else {

                        Alert.error(result.message)
                        this.setState({ isLoading: false, isdataLoaded: false })
                    }                    

                })
                .catch((error) => {

                    console.log(error)
                    Alert.error("Gagal terhubung ke server!")
                    this.setState({ isLoading: false, isdataLoaded: false })
                })
        }
        
    }

    componentDidMount() {

        this.loadData();
        this.loadDataKelas();
        this.loadDataMapel();
    }
    
    render() {
        
        return (
            <div className="col-sm-12">                
                <div className="card">
                    <div className="card-header">
                        {this.props.mode} Data Materi Video
                    </div>
                    <div className="card-block">
                    {
                        this.state.isLoading ? 'Memuat Data...' : 
                            this.props.mode === "Edit" && ! this.state.isdataLoaded ? 
                                <div>Data gagal dimuat... <button className="btn-link" onClick={() => this.loadData()}><i className="fa fa-refresh"></i> Muat Ulang</button></div> : (
                                    <div className="form-horizontal animated fadeIn">
                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">Kelas</label>
                                            <div className="col-md-10">
                                                <Select
                                                    multi
                                                    value={this.state.participants}
                                                    onChange={text =>
                                                        this.handleChangeMultiSelect("participants", text)
                                                    }
                                                    options={this.state.dataKelas}
                                                    placeholder="Kelas yang mengikuti"
                                                    removeSelected={this.state.removeSelected}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">Mata Pelajaran</label>
                                            <div className="col-md-10">
                                                <FormDropdown
                                                    items={this.state.dataMapel}
                                                    onChange={this.handleChange}
                                                    value={this.state.mapel_id.toString()}
                                                    name="mapel_id"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">Judul Materi Video</label>
                                            <div className="col-md-10">
                                                <input 
                                                    name="materi_judul"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Nama Judul Materi" 
                                                    onChange={this.handleChange} 
                                                    value={this.state.materi_judul} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">URL Youtube
                                            <br />
                                            {/*<small className="text-muted">*/}
                                            {/*    <table>*/}
                                            {/*        <tr>*/}
                                            {/*            <td style={{verticalAlign: "top"}}><i className="fa fa-info-circle"></i>{" "}</td>*/}
                                            {/*            <td>Ambil kode di belakang tanda = (sama dengan) pada link url</td>*/}
                                            {/*        </tr>*/}
                                            {/*    </table>                        */}
                                            {/*</small>*/}
                                            </label>
                                            <div className="col-md-10">
                                                <input 
                                                    name="materi_file"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Link Materi Video" 
                                                    onChange={this.handleChange} 
                                                    value={this.state.materi_file} />
                                            </div>
                                        </div>                                 
                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">Status Aktif</label>
                                            <div className="col-md-10">
                                                <FormDropdown
                                                    items={status_aktif}
                                                    onChange={this.handleChange}
                                                    value={this.state.materi_status}
                                                    name="materi_status"
                                                />
                                            </div>
                                        </div>                         
                                    </div>
                                )
                    }
                    </div>
                    <div className="card-footer">
                        <button 
                            type="button" 
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Simpan"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Forms;


// WEBPACK FOOTER //
// ./src/views/Video/Forms.js